export default {"src":"/_next/static/media/Shower.b2ed3542.svg","height":15,"width":18,"blurWidth":0,"blurHeight":0};